import React, { useState, useEffect } from 'react'
import { getSeasons } from '../api'
import StarsBody from '../styles/stars'
import { getPersianNumber } from '../utils/number'
import MainHeader from '../views/MainHeader'
import { useHistory } from 'react-router-dom'
import SeasonsList from '../views/SeasonSection'

const useSeasons = () => {
  const [seasons, setSeasons] = useState()
  useEffect(() => {
    const getSeasonsResponse = async () => {
      const seasonsResponse = await getSeasons()
      setSeasons(seasonsResponse)
    }
    getSeasonsResponse()
  }, [])
  return seasons
}

export default ({ loyalty: { status: { point } } }) => {
  const history = useHistory()
  var seasons = useSeasons()
  seasons && (
    seasons = seasons.seasons
  )
  const onBack = () => history.push('/store')

  return (
    <>
      <MainHeader
        backgroundImage={require(`../planets/planet.png`)}
        hasHelpButton
        goHome={onBack}
        point={getPersianNumber(point)}
      />
      <StarsBody>
        {seasons && seasons.map((season, index) =>
          <SeasonsList key={index} season={season} />
        )}
      </StarsBody>
    </>
  )
}
